import { MdError } from 'react-icons/md';
import { ConstraintValidation } from '@blisspointmedia/bpm-types/dist/OptimizationConstraints';
import { IconButton } from '@Components/IconButton';
import { Appearance, Intent, Size } from '@Components/designConstants';

export const ConstraintWarning = ({ isError }: ConstraintValidation) =>
  isError ? (
    <IconButton
      appearance={Appearance.EMPTY}
      design={Intent.ERROR}
      size={Size.SM}
      aria-label={`Constraint warning: ${isError}`}
      tooltip={{ text: isError }}
    >
      <MdError aria-hidden />
    </IconButton>
  ) : null;
